import { Injectable } from '@angular/core';
import { firstTruthy, startup } from '@shared/rxjs-operators';
import { BehaviorSubject, finalize, Observable, of, tap } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { IxlabFrontendConfigDto } from '../../.api-client/models/ixlab-frontend-config-dto';
import { AgentDataForTokenApiService } from '../../.api-client/services/agent-data-for-token-api.service';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    private readonly configSubject: BehaviorSubject<IxlabFrontendConfigDto | undefined> = new BehaviorSubject<IxlabFrontendConfigDto | undefined>(
        undefined,
    );
    public readonly configObs = this.configSubject.asObservable();

    private isLoadingConfig: boolean = false;

    constructor(private readonly _agentDataForTokenApiService: AgentDataForTokenApiService) {}

    public getIxlabFrontendConfig(): Observable<IxlabFrontendConfigDto> {
        const existingConfig = this.configSubject.getValue();

        if (existingConfig) {
            return of(existingConfig);
        }

        // TODO: Mit loadingObs umsetzen, darauf warten, dass nicht mehr geladen wird, und neuen Wert verwenden
        // Aktuell wird hier, wenn gerade geladen wird, der alte Wert verwendet
        if (this.isLoadingConfig) {
            return this.configObs.pipe(firstTruthy());
        }

        return this._agentDataForTokenApiService.agentGetAgentConfig({ 'x-trace-id': uuidv4() }).pipe(
            startup(() => (this.isLoadingConfig = true)),
            tap((config) => this.configSubject.next(config)),
            finalize(() => (this.isLoadingConfig = false)),
        );
    }
}
